"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function asyncGeneratorStep(e, t, n, o, a, s, i) {
  try {
    var r = e[s](i),
      l = r.value;
  } catch (e) {
    return void n(e);
  }
  r.done ? t(l) : Promise.resolve(l).then(o, a);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      n = arguments;
    return new Promise(function (o, a) {
      var s = e.apply(t, n);
      function i(e) {
        asyncGeneratorStep(s, o, a, i, r, "next", e);
      }
      function r(e) {
        asyncGeneratorStep(s, o, a, i, r, "throw", e);
      }
      i(void 0);
    });
  };
}
var CLASS_NAME = ":WidgetDH:",
  _exports = {},
  sections = [];
function getInitialInfoLocalV1(e) {
  return _getInitialInfoLocalV.apply(this, arguments);
}
function _getInitialInfoLocalV() {
  return (_getInitialInfoLocalV = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
    var n, o, a;
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          n = ":getIntialInfo:", o = (t = t ? {
            widget_type: t
          } : {
            widget_type: "Life"
          }).widget_type, e.t0 = o, e.next = "Life" === e.t0 ? 6 : "HomeLife" === e.t0 ? 10 : 14;
          break;
        case 6:
          return sections.push({
            name: "information",
            title: "Add another layer of protection to your real estate assets",
            style: "header",
            alt_text: "Add another layer of protection to your real estate assets",
            text: "EMPTY"
          }), sections.push({
            name: "information",
            title: "EMPTY",
            style: "tagline",
            alt_text: "Life Insurance for landlords. Fast. Easy. Online",
            text: "Life Insurance for landlords. Fast. Easy. Online"
          }), sections.push({
            name: "links",
            title: "Partnered with the best",
            style: "EMPTY",
            alt_text: "Bubble's partner logos",
            sections: ["https://devuiassetscdn.getmybubble.io/images/paclife-logo.jpg", "https://devuiassetscdn.getmybubble.io/images/sbli-logo.jpg", "https://devuiassetscdn.getmybubble.io/images/symetra.png"]
          }), e.abrupt("break", 15);
        case 10:
          return sections.push({
            name: "information",
            title: "Protect your home & loved ones with personalized home and life insurance",
            style: "header",
            alt_text: "Add another layer of protection to your real estate assets",
            text: "EMPTY",
            sections: []
          }), sections.push({
            name: "information",
            title: "EMPTY",
            style: "tagline",
            alt_text: "Fast. Easy. Online. Affordable.",
            text: "Fast. Easy. Online. Affordable.",
            sections: []
          }), sections.push({
            name: "links",
            title: "Partnered with the best",
            style: "EMPTY",
            alt_text: "Bubble's partner logos",
            sections: ["https://devuiassetscdn.getmybubble.io/images/stillwater-logo.png", "https://devuiassetscdn.getmybubble.io/images/paclife-logo.jpg", "https://devuiassetscdn.getmybubble.io/images/sbli-logo.jpg", "https://devuiassetscdn.getmybubble.io/images/symetra.png"]
          }), e.abrupt("break", 15);
        case 14:
          return e.abrupt("break", 15);
        case 15:
          return {
            sections: sections,
            client_id: "w2e3r4",
            token1: "p0o9i8u7y6"
          }, sections.push({
            name: "information",
            title: "EMPTY",
            style: "footer",
            alt_text: "Powered by Bubble Technologies",
            text: "Powered by Bubble Technologies",
            sections: ["https://public-bubble.s3-us-west-2.amazonaws.com/images/bubble-logo-from-header1-q79xfl.svg"]
          }), console.log("Entered:Input: inputJson:", t, n, CLASS_NAME), a = {
            src: "base64code"
          }, e.abrupt("return", new Promise(function (e, t) {
            e({
              statusCode: 200,
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Headers": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "*"
              },
              multiValueHeaders: null,
              body: JSON.stringify(a),
              isBase64Encoded: !1
            });
          }));
        case 20:
        case "end":
          return e.stop();
      }
    }, e);
  }))).apply(this, arguments);
}
function submitDataLocalV1(e) {
  return _submitDataLocalV.apply(this, arguments);
}
function _submitDataLocalV() {
  return (_submitDataLocalV = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
    var n, o, a, s;
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          ":submitData:", t = t ? {
            widget_type: t
          } : {
            widget_type: "Life"
          }, console.log("Entered:Input: inputJson:", t, ":submitData:", CLASS_NAME), n = t.widget_type, a = {
            client_id: o = "w2e3r4",
            token1: "p0o9i8u7y6"
          }, s = [], e.t0 = n, e.next = "Life" === e.t0 ? 10 : 14;
          break;
        case 10:
          return sections.push({
            name: "information",
            title: "EMPTY",
            style: "greentick_line",
            alt_text: "No medical check-up required in most cases below the age of 40.",
            text: "No medical check-up required in most cases below the age of 40."
          }), sections.push({
            name: "information",
            title: "EMPTY",
            style: "greentick_line",
            alt_text: "Coverage from a minimum of $250K to a maximum of $10M",
            text: "Coverage from a minimum of $250K to a maximum of $10M"
          }), sections.push({
            name: "button_link",
            title: "EMPTY",
            style: "EMPTY",
            alt_text: "EMPTY",
            text: "https://quotedev.getmybubble.io/resumeFlow/".concat(o)
          }), e.abrupt("break", 15);
        case 14:
          return e.abrupt("break", 15);
        case 15:
          return a.life_sections = s, e.abrupt("return", new Promise(function (e, t) {
            e({
              statusCode: 200,
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Headers": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "*"
              },
              multiValueHeaders: null,
              body: JSON.stringify(outputJson),
              isBase64Encoded: !1
            });
          }));
        case 17:
        case "end":
          return e.stop();
      }
    }, e);
  }))).apply(this, arguments);
}
function getData4TokenLocalV1() {
  return _getData4TokenLocalV.apply(this, arguments);
}
function _getData4TokenLocalV() {
  return (_getData4TokenLocalV = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
    var t,
      n,
      o,
      a,
      s,
      i,
      r = arguments;
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return t = r.length > 0 && void 0 !== r[0] ? r[0] : "p0o9i8u7y6", n = require("./helper/imageConverter/bls2.service"), o = new n.BusinessLogicService2(), a = {
            tokenId: t,
            fontsize: 22,
            fontcolor: "black",
            width: 40,
            height: 25,
            fontweight: "bolder",
            fontfamily: "poppins",
            lineHeight: 1
          }, s = "$41.95", o.createimg(a.fontsize, a.fontcolor, s, a.width, a.height, a.fontweight, a.fontfamily), i = {
            src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAZCAYAAABD2GxlAAAA30lEQVRYR+2VSw6AMAgF9f6H1mgkwRc+j6LGRV0aSqcDpevy82/9Od8yAbsVmganwa6B7vrZg28Y3CApa1nWefFDeTGZtcnxj4GMABFOHKR5LUAGGiunAZj1Ufwtt07GGLBOLIa99V4FspY4Qb8A9O7JJ4DaDrWhoqXiOwaxdNSGADh0SbzSW//ZA3qXqgx4JLLmFdqxGr9ikB1dQ/OtdSsvAak5elAqo5LUG7pYxuhFeQywWjbsU6v3aDgmWRajAbLDRK3hQnsvQ6UFJJZ5iayhHRq1xkTFGmMw69kQcAf3oj8af09vagAAAABJRU5ErkJggg=="
          }, e.abrupt("return", new Promise(function (e, t) {
            e({
              statusCode: 200,
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Headers": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "*"
              },
              multiValueHeaders: null,
              input: JSON.stringify(a),
              output: JSON.stringify(i),
              isBase64Encoded: !1
            });
          }));
        case 8:
        case "end":
          return e.stop();
      }
    }, e);
  }))).apply(this, arguments);
}
function updateHubSpotContactByEmail(e) {
  return _updateHubSpotContactByEmail.apply(this, arguments);
}
function _updateHubSpotContactByEmail() {
  return (_updateHubSpotContactByEmail = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
    var n;
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          if (window) {
            e.next = 2;
            break;
          }
          return e.abrupt("return");
        case 2:
          return "https://api2.getmybubble.io/fetch1", e.next = 5, fetch("https://api2.getmybubble.io/fetch1", {
            method: "POST",
            body: t,
            headers: {
              "Content-Type": "application/json"
            }
          });
        case 5:
          return n = e.sent, e.abrupt("return", n);
        case 7:
        case "end":
          return e.stop();
      }
    }, e);
  }))).apply(this, arguments);
}
_exports.updateBubbleHubSpotContactByEmail = function (e) {
  return updateHubSpotContactByEmail(e);
}, _exports.getInitialInfo = function (e) {
  return getInitialInfoLocalV1(e);
}, _exports.submitData = function (e) {
  return submitDataLocalV1(e);
}, _exports.getData4Token = function (e) {
  return getData4TokenLocalV1(e);
};